import draftToHtml from 'draftjs-to-html';

/**
 * Converts Draft.js raw content state (JSON) to HTML string
 * @param {string|object} value - Draft.js content as JSON string or parsed object
 * @returns {string} HTML string representation of the Draft.js content
 */
export const convertDraftJsToHtml = (value) => {

  // Handle empty or null values
  if (!value || value === '' || value === null || value === undefined) {
    return '';
  }

  // If value is already a string, try to parse it
  let rawContentState;

  if (typeof value === 'string') {
    try {
      rawContentState = JSON.parse(value);
    } catch (e) {
      // If parsing fails, return empty string or the original value
      // This handles cases where value might be plain HTML or other format
      return '';
    }
  } else if (typeof value === 'object') {
    rawContentState = value;
  } else {
    return '';
  }

  // Validate that it's a Draft.js format (has blocks property)
  if (!rawContentState || !rawContentState.blocks || !Array.isArray(rawContentState.blocks)) {
    return '';
  }

  // Ensure entityMap exists (required by draftjs-to-html)
  if (!rawContentState.entityMap) {
    rawContentState.entityMap = {};
  }

  try {
    // Convert Draft.js raw content state to HTML
    const html = draftToHtml(rawContentState);
    return html || '';
  } catch (error) {
    // If conversion fails, return empty string
    console.warn('Failed to convert Draft.js content to HTML:', error);
    return '';
  }
};

export default convertDraftJsToHtml;
